<template>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab" @click="clickCollapse">
      {{lessonContent.title}}
    </b-card-header>
    <b-collapse id="accordion-1" :visible="isOpen" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-container   v-if="lessonContent.popupInfo">
          <b-row class="my-1">
            <b-col sm="3">
              <label>미션 해제 팝업</label>
            </b-col>
            <b-col sm="9">
              <div>핍업 제목 : {{lessonContent.popupInfo.title}}</div>
              <div>팝업 내용 : {{lessonContent.popupInfo.content}}</div>
            </b-col>
          </b-row>
          <hr/>
        </b-container>
        <h5>동영상 리스트</h5>
        <b-container :key="index" v-for="(video, index) in lessonContent.videos">
          <b-row class="my-1"  v-if="video.popupInfo">
            <b-col sm="3">
              <label>수업 완료 팝업</label>
            </b-col>
            <b-col sm="9">
              <div>핍업 제목 : {{video.popupInfo.title}}</div>
              <div>팝업 내용 : {{video.popupInfo.content}}</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>제목</label>
            </b-col>
            <b-col sm="10">
              {{video.title}}
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>url</label>
            </b-col>
            <b-col sm="10">
              {{video.url}}
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: "LessonDetailCollapse",
  props: ['lessonContent'],
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    clickCollapse () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped>

</style>